import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './dashboard.css';

/**
 * 登录后访问 /dashboard 的入口分发（spec §4.3，镜像 AIQ）。
 *
 * - 超管 / 系统管理员（无所属企业）→ /dashboard/enterprises（企业选择器）
 * - 裸码企业（enterprise_classes_enabled === false）→ /dashboard/enterprises/{id}（全员看板）
 * - 其余（班级制企业 / 讲师）→ /dashboard/classes
 *
 * enterprise_classes_enabled 由 /api/auth/me/ 提供（UserSerializer）。
 */
export default function DashboardEntryRedirect() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="aiq-dash dash-page"><div className="dash-card">正在打开看板...</div></div>;
  }
  if (user && !user.enterprise_id && ['superadmin', 'admin'].includes(user.role)) {
    return <Navigate to="/dashboard/enterprises" replace />;
  }
  if (user && user.enterprise_id && user.enterprise_classes_enabled === false) {
    return <Navigate to={`/dashboard/enterprises/${user.enterprise_id}`} replace />;
  }
  return <Navigate to="/dashboard/classes" replace />;
}
